// extracted by mini-css-extract-plugin
module.exports = {"link":"ySNtpgF9y8vmS0n8MGmjB"};